import { SelectOptions } from "../../../components/Select/Select"

export const options: SelectOptions = [
  {
    id: "g1",
    value: 1,
    label: "Årskurs 1"
  },
  {
    id: "g2",
    value: 2,
    label: "Årskurs 2"
  },
  {
    id: "g3",
    value: 3,
    label: "Årskurs 3"
  }
]
export const pdfOptions: SelectOptions = [
  {
    id: "p1",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_1.pdf",
    label: "Målöversikt Årskurs 1"
  },
  {
    id: "p2",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_2.pdf",
    label: "Målöversikt Årskurs 2"
  },
  {
    id: "p3",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_3.pdf",
    label: "Målöversikt Årskurs 3"
  },
  {
    id: "p4",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_4.pdf",
    label: "Målöversikt Årskurs 4"
  },
  {
    id: "p5",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_5.pdf",
    label: "Målöversikt Årskurs 5"
  },
  {
    id: "p6",
    value:
      "https://storage.googleapis.com/studli-prod-tecla-media/teacher-material/Tomoyo_innehall_ak_6.pdf",
    label: "Målöversikt Årskurs 6"
  }
]
